export const SITE = 'https://externaldisplayiphone.com';

/** Trims to a search-engine-safe length at a word boundary, marked with an ellipsis. */
function truncate(str, max, minBreak) {
  if (!str || str.length <= max) return str;
  const cut = str.slice(0, max);
  const lastSpace = cut.lastIndexOf(' ');
  return (lastSpace > minBreak ? cut.slice(0, lastSpace) : cut).trimEnd() + '…';
}


/** "<SEO title> | XeOS". scripts/build-content.mjs keeps every article's SEO title
 *  short enough (content/seo-titles.json) that this stays within 65 characters. */
export const pageTitle = (title) => `${title} | XeOS`;

export const truncateDescription = (str, max = 155) => truncate(str, max, 60);

/** Points <link rel="canonical"> and og:url at the current path, so every
 * page declares itself (not some other page) as its own canonical version. */
export function setCanonical(pathname) {
  if (typeof document === 'undefined') return;
  const url = SITE + pathname;
  let link = document.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement('link');
    link.rel = 'canonical';
    document.head.appendChild(link);
  }
  link.href = url;
  const ogUrl = document.querySelector('meta[property="og:url"]');
  if (ogUrl) ogUrl.setAttribute('content', url);
}
